import produce from 'immer'
import { difference, keys, merge } from 'lodash'
import { useEffect, useState } from 'react'

import {
    BoardEvent,
    DragDropData,
    ItemListBasicType,
    OptimisticLocalState,
    ServerEventStatus,
    State
} from '../dtos'

export interface UseOptimisticRendering {
    data: DragDropData
    setState: React.Dispatch<React.SetStateAction<State>>
}

export const useOptimisticRendering = (props: UseOptimisticRendering) => {
    const { data, setState } = props

    // Array that contains all the actions (create, delete, move),
    // the state of the full app for each call (would allow time travel)
    // and the status of the server calls.
    const [optimisticState, setOptimisticState] = useState<
        OptimisticLocalState
    >({
        event: []
    })

    useEffect(() => {
        console.log('optimisticState', optimisticState)
    }, [optimisticState])
    const [isFirstLoadFinished, setIsFirstLoadFinished] = useState(false)

    // Updates local state with data coming from server
    // uses optimistic, or not.
    useEffect(() => {
        let itemsBasicProps: ItemListBasicType = {}
        for (let key of Object.keys(data.items)) {
            itemsBasicProps[key] = { id: key }
        }

        // Optimistic Rendering
        if (isFirstLoadFinished) {
            setState((state) => {
                const lastOptimisticData =
                    optimisticState.event[optimisticState.event.length - 1]
                if (lastOptimisticData) {
                    const createdItemList = data.items

                    // List the new items from server
                    const listAllNewItemsFromServer = difference(
                        keys(createdItemList),
                        keys(state.items)
                    )
                    console.log('CN', listAllNewItemsFromServer)

                    // If the server does not have the newly created items yet, do NOT
                    // refresh using only the data from the server.
                    // Instead, merge data inside local state, taking into account optimistic stuff
                    // const dataToState: State = {...data, itemsBasicProps: }
                }

                const mergedData: DragDropData = merge(data, state)
                console.log('data', data)
                console.log('state', state)
                console.log('mergedData', mergedData)
                return { ...mergedData, itemsBasicProps }
            })
            setIsFirstLoadFinished(true)
        }

        // First Load (nothing optimistic here)
        if (!isFirstLoadFinished) {
            setState({ ...data, itemsBasicProps })
            setIsFirstLoadFinished(true)
        }
    }, [data, isFirstLoadFinished])

    return {
        optimisticState,
        setOptimisticState
    }
}
